import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import useFeatureFlags from "./useFeatureFlags";
import { useSelector } from "react-redux";
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper";
import { getCurrentBrandFromLocalStorage } from "helpers/sf_utils";

const useUrlFilter = () => {

    const { current_account, brands } = useSelector(state => ({
        current_account: state.accounts.current_account,
        brands: state.Brands.brands
    }))
    const searchParams = new URLSearchParams(window.location.search);
    const [isFeatureFlagActive] = useFeatureFlags();
    const current_brand = getCurrentBrandFromLocalStorage()
    const brandId = searchParams.get('brand_id') || current_brand?.id;

    const getNewUrl = (urlFilters, individualPageFeatureFlag = REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_URL_FILTERS) => {
        if (!isFeatureFlagActive(individualPageFeatureFlag)) {
            return '';
        }
        const updatedParams = new URLSearchParams();
        //We are adding admin=true to check if who is sharing url - is it being shared by admin or by client
        if (bsh_isAdminUserDetailsPresent()) {
            updatedParams.append('admin_user', true)
        }
        if (current_account) {
            updatedParams.append('account_id', current_account?.id)
            if (brands.length > 0) {
                updatedParams.append('brand_id', brandId)
            }
        }
        updatedParams.append('filters', encodeURIComponent(JSON.stringify(urlFilters)));
        const newURL = `${window.location.pathname}?${updatedParams.toString()}`;
        return newURL
    }

    return getNewUrl;
}

export default useUrlFilter;
